/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TemperatureUnit = {
    DegreeCelsius: 'TemperatureUnit.DegreeCelsius',
    DegreeDelisle: 'TemperatureUnit.DegreeDelisle',
    DegreeFahrenheit: 'TemperatureUnit.DegreeFahrenheit',
    DegreeNewton: 'TemperatureUnit.DegreeNewton',
    DegreeRankine: 'TemperatureUnit.DegreeRankine',
    DegreeReaumur: 'TemperatureUnit.DegreeReaumur',
    DegreeRoemer: 'TemperatureUnit.DegreeRoemer',
    Kelvin: 'TemperatureUnit.Kelvin',
    MillidegreeCelsius: 'TemperatureUnit.MillidegreeCelsius',
    SolarTemperature: 'TemperatureUnit.SolarTemperature'
} as const;
export type TemperatureUnit = typeof TemperatureUnit[keyof typeof TemperatureUnit];


export function TemperatureUnitFromJSON(json: any): TemperatureUnit {
    return TemperatureUnitFromJSONTyped(json, false);
}

export function TemperatureUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemperatureUnit {
    return json as TemperatureUnit;
}

export function TemperatureUnitToJSON(value?: TemperatureUnit | null): any {
    return value as any;
}

/**
 * Check if a given object implements the TemperatureUnit interface.
 */
 export function instanceOfTemperatureUnit(value: any): value is TemperatureUnit {
    return Object.values(TemperatureUnit).includes(value)
}

